import { fieldWithTranslationSchema, imageMultiSchema, multiSelectionSchema, numberSchema, stringSchema } from "components/inputs/validationSchema";
import { TFunction } from "i18next";
import * as yup from "yup";

export const fieldNames = {
  title: "title",
  description: "description",
  images: "images",
  url: "url",
  listOrderNumber: "listOrderNumber",
  categoryIds: "categoryIds",
} as const;

export const validation = (_id: string | undefined, t: TFunction) =>
  yup.object().shape({
    [fieldNames.title]: fieldWithTranslationSchema(fieldNames.title, t),
    [fieldNames.description]: fieldWithTranslationSchema(fieldNames.description, t),
    [fieldNames.images]: imageMultiSchema(fieldNames.images, t),
    [fieldNames.url]: stringSchema(fieldNames.url, t),
    [fieldNames.listOrderNumber]: numberSchema(fieldNames.listOrderNumber, t),
    [fieldNames.categoryIds]: multiSelectionSchema(fieldNames.listOrderNumber, t),
    //   [fieldNames.categoryIds]: yup
    // .array()
    // .of(
    //   yup.object().shape({
    //     value: yup.string().required(),
    //     label: yup.string().required(),
    //   })
    // )
    // .min(1, t("pleaseSelect", { changeablePart: t("categories") }))
    // .required(t("pleaseSelect", { changeablePart: t("categories") })),
  });
